import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";

export const Title = styled(Grid)(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "1rem",
  lineHeight: "18px",
  color: "#465869",
  margin: "0.5rem 0 1.25rem 0",
}));

export const Buttons = styled("div")(() => ({
  borderTop: "1px solid #e4e7ec",
  display: "flex",
  justifyContent: "flex-end",
  padding: "1rem",
  margin: "-16px",
}));

export const CarrierInfoWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 12,
}));

export const InfoSpan = styled("span")(({ bold }: { bold?: boolean }) => ({
  display: "flex",
  alignItems: "center",
  gap: 4,

  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: bold ? 600 : 400,
  lineHeight: "20px",
  letterSpacing: bold ? "0.1px" : "0.25px",

  color: "#475467",
}));

export const CheckIcon = styled(AiOutlineCheck)(() => ({
  color: "#039855",
  fontSize: 18,
}));

export const CloseIcon = styled(AiOutlineClose)(() => ({
  fontSize: 18,
  color: "#D92D20",
}));

const styles = makeStyles(() => ({
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "18px",
    color: "#465869",
    margin: "8px 0px 20px 0px",
  },
  agentName: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "0.875rem",
    lineHeight: "18px",
    color: "#667085",
    marginBottom: "1rem",
  },
  mb16: {
    marginBottom: "16px",
  },
  icon: {
    fontSize: "22px",
  },
  iconButton: {
    padding: "8px",
  },
  iconsContainer: {
    display: "flex",
  },
  pt0: {
    paddingTop: "0px !important",
  },
}));

export default styles;
